import { contextConnect, useContextSystem } from '@wp-g2/context';
import { ui } from '@wp-g2/styles';
import React from 'react';
import { AnimatedContainer } from '../Animated';
import { View } from '../View';

function Alerts(props, forwardedRef) {
  var otherProps = useContextSystem(props, 'Alerts');
  return /*#__PURE__*/React.createElement(View, Object.assign({
    ref: forwardedRef
  }, ui.$('Alerts')), /*#__PURE__*/React.createElement(AnimatedContainer, otherProps));
}

export default contextConnect(Alerts, 'Alerts');